import React from "react";
import { FaInstagram } from "react-icons/fa";
import { CiFacebook } from "react-icons/ci";
import { CiLinkedin } from "react-icons/ci";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaGithubSquare } from "react-icons/fa";
import { SiGmail } from "react-icons/si";

const Footer = () => {
  return (
    <>
      <div className="container contact" id="contact">
        <div className="row">
          <div className="col-12 contact-icon" data-aos="zoom-in-up" data-aos-duration="1000">
              <a href="https://www.linkedin.com/in/akash-kumar-26a2b1218/" target="_blank" className="items">
                  <CiLinkedin className="icons" />
              </a>
              <a href="https://www.instagram.com/akash_gupta_2304/?hl=en" target="_blank" className="items">
                  <FaInstagram className="icons" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=100085605041647" target="_blank" className="items">
                  <CiFacebook className="icons" />
              </a>
              <a href="https://x.com/AkashKu99318871?t=JyGipgyM2LTbeZ3usQw1hg&s=09" target="_blank" className="items">
                  <FaSquareXTwitter className="icons" />
              </a>
              <a href="https://github.com/AkashKumar2011" target="_blank" className="items">
                  <FaGithubSquare className="icons" />
              </a>
              <a href="mailto:kumarakash20112000@gmail.com" target="_blank" className="items" >
                  <SiGmail className="icons" />
              </a>
          </div>
          <div className="col-12">
            <hr />
            <p class="text-center my-4"> 
              &copy; Copyright 2024  
              <span className="footer-damain-name font-bold"> {"  "} akashkumarportfolio.online  {"  "} </span>  
              All Rights Reserved. 
            </p> 
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
